export const getFetchConfig = (request) => {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json')
    headers.append('authorization', 'Bearer ' + request.token)
    headers.append('xdata-expand-level', (request.depth || 0).toString())
    const config = {
        method: request.method,
        headers: headers,
    }

    if (request.params !== undefined)
        if (request.method.toLowerCase() !== 'get') {
            config.body = JSON.stringify(request.params)
        }

    return config
}



export const fetchServer = (request, onSuccess, onError) => {
    const url = request.endPoint
    var contentType;
    return fetch(url, getFetchConfig(request))
        .then(response => {
            if (!response.ok) {
                contentType = response.headers.get('content-type');
                if (contentType && contentType.indexOf('application/json') !== -1) {
                    return response.json().then(function (json) {
                        onError(json);
                    });

                } else {
                    return response.text().then(function (json) {
                        onError(json);
                    });
                }
            }

            contentType = response.headers.get('content-type');
            if (contentType && contentType.indexOf('application/json') !== -1) {
                return response.json().then(function (json) {
                    onSuccess(json)
                });
            } else {
                return response.text().then(function (text) {
                    onSuccess(text)
                });
            }
        })
        .catch(error => onError(error))
}